import React, { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Table } from 'react-bootstrap'
import BtnBack from '../../../components/btn-back'
import { PAGE_INCOME_DILIG } from '../../../router/routes'
import { useSearchParams } from 'react-router-dom'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { detailIncomeDiligenceAPI } from '../../../services/income/diligence'

export default function DetailCertificateIncomePage() {
  let [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const totalLimits = 20
  const [page, setPage] = useState(1)
  const [bodyFilter, setBodyFilter] = useState()
  const [totalRows, setTotalRows] = useState(0)

  useEffect(() => {
    const body = {
      periodDate: id,
      page: 1,
      size: totalLimits
    }
    fnGetData(body)
  }, [id])
  const [dataTable, setDataTable] = useState([])
  const fnGetData = async (body) => {
    setBodyFilter(body)
    const resp = await detailIncomeDiligenceAPI(body)
    if (!resp) return
    if (resp.result) {
      setDataTable(resp.result)
      setTotalRows(resp.totalRows)
    } else {
      setDataTable([])
      setTotalRows(0)
    }
  }

  return (
    <div>
      <NavTitle>
        <TextNavTitle>
          <BtnBack
            to={PAGE_INCOME_DILIG}
            text={'Back'}
            className={'text-muted'}
          />
        </TextNavTitle>
      </NavTitle>
      <CardCustom className="d-flex justify-content-between ">
        <div>
          <div className="p-3 d-flex justify-content-between ">
            <h6 className="mb-0">Total: {totalRows}</h6>
            <label>Date: 12/2024</label>
          </div>
          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className=" font-title-table">
                <th className="fw-normal">#</th>
                <th className="fw-normal">ORG</th>
                <th className="fw-normal">Code</th>
                <th className="fw-normal">Name</th>
                <th className="fw-normal">ID Card</th>
                <th className="text-end fw-normal">Amount</th>
              </tr>
            </thead>
            <tbody>
              {dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr key={i} className="font-small-2 align-middle">
                    <td>{page * totalLimits - totalLimits + i + 1}</td>
                    <td>{d.org}</td>
                    <td>{d.code}</td>
                    <td>
                      {d.titleTh}
                      {d.nameTh} {d.surnameTh}
                    </td>
                    <td>{d.idCard}</td>
                    <td className="text-end">
                      {' '}
                      {d.diligenceAmounts?.toLocaleString()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="text-center" colSpan={6}>
                    - No Data -
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="p-3">
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>
    </div>
  )
}
